export default __webpack_public_path__ + "3832bc3213950c6b41a5904b7bfcf0a9.svg";